import SpeechBubble from './SpeechBubble';

export default SpeechBubble;
